import { replaceableContext } from './replaceable.context';

export const sharedContext = {
  replaceable: replaceableContext,
};
